export default "__VITE_ASSET__tCj0_51a__"